(function() {
    // Ensure we have the config object available
    if (!window.buttonClickConfig) {
      return;
    }
  
    var clickAction = window.buttonClickConfig.action || 'open';
    var externalWhitelist = window.buttonClickConfig.whitelist || '';
  
    // Convert the comma-separated whitelist into an array of trimmed domain strings
    var whitelistDomains = externalWhitelist
      .split(',')
      .map(function(domain) { return domain.trim(); })
      .filter(function(domain) { return domain.length > 0; });
  
    /**
     * Checks if a URL is considered external based on the whitelist.
     * @param {string} href - The link's href attribute value
     * @returns {boolean} true if external (and not on the whitelist); false otherwise
     */
    function isExternalLink(href) {
        try {
          var linkHostname = new URL(href, window.location.origin).hostname.toLowerCase();
      
          // Check if link is same as current host
          if (linkHostname === window.location.hostname.toLowerCase()) {
            return false; // Definitely internal
          }
      
          // If any whitelisted domain is an exact match or the linkHostname ends with "." + whitelistedDomain
          var isWhitelisted = whitelistDomains.some(function(whitelistedDomain) {
            whitelistedDomain = whitelistedDomain.toLowerCase();
      
            return (
              linkHostname === whitelistedDomain ||
              linkHostname.endsWith("." + whitelistedDomain)
            );
          });
      
          // If not whitelisted and not the same host => external
          return !isWhitelisted;
        } catch (e) {
          // If parsing fails or it's a relative link, treat as internal (not external)
          return false;
        }
      }
  
    /**
     * Applies the correct target and rel attributes to a link based on current clickAction.
     * @param {HTMLAnchorElement} anchor - The anchor element to handle.
     */
    function configureLink(anchor) {
      // Always read the href; if no href or it's just "#", skip modifications
      var href = anchor.getAttribute('href');
      if (!href || href.trim() === '#') {
        return;
      }
  
      switch (clickAction) {
        case 'open_new':
          anchor.setAttribute('target', '_blank');
          break;
  
        case 'external_new_tab':
          if (isExternalLink(href)) {
            anchor.setAttribute('target', '_blank');
          }
          break;
        default:
        //   anchor.removeAttribute('target');
        //   anchor.removeAttribute('rel');
          break;
      }
    }
  
    /**
     * Processes all anchor tags on page to apply link behavior.
     */
    function processLinks() {
      var anchorTags = document.querySelectorAll('a');
      anchorTags.forEach(configureLink);
    }

    /**
     * Applies configureLink to a node added after initial load: the node
     * itself when it is an anchor, plus any anchors inside it.
     * @param {Node} node - The newly added DOM node.
     */
    function configureAddedNode(node) {
      if (node.nodeType !== 1) {
        return;
      }
      if (node.tagName === 'A') {
        configureLink(node);
      }
      var nested = node.querySelectorAll('a');
      if (nested.length) {
        nested.forEach(configureLink);
      }
    }

    /**
     * Watches for anchors added after the initial pass and configures them.
     * The theme injects links into the DOM after load in at least three
     * places, none of which the single DOMContentLoaded pass could reach:
     * the cart drawer (cart-ajax.js loads /cart?view=jsonData into
     * [data-drawer-body]), Quick View (common.js fetches ?view=quick-view
     * and injects it), and the header/hero predictive search dropdown
     * (header.liquid writes fetched results into .slhub-dropdown__results).
     * Megamenu panels, the newsletter popup and the side drawer are all
     * server-rendered and were already covered by the initial pass, despite
     * being listed as dynamic in the spec.
     */
    function watchForAddedLinks() {
      if (clickAction !== 'open_new' && clickAction !== 'external_new_tab') {
        return;
      }
      if (typeof MutationObserver === 'undefined' || !document.body) {
        return;
      }
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            configureAddedNode(added[j]);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }

    // Wait for DOM to fully load before processing
    document.addEventListener('DOMContentLoaded', function () {
      processLinks();
      watchForAddedLinks();
    });
  })();
